import { object, string, array } from 'yup';
import addEmailValidation from '@afosto/utils-react/validators/validEmail';

addEmailValidation();

export default object().shape({
  to: array().of(string().validEmail()).required(),
  cc: array().of(string().validEmail()),
  bcc: array().of(string().validEmail()),
  subject: string().required(),
  content: string().required(),
});
